import * as amplitude from '@amplitude/analytics-browser';
import { ApolloProvider } from '@apollo/client/react';
import { loadSentry } from '@opendoor/observability/sentry';
import { loadGoogleTagManager } from '@opendoor/shared-fe/googleTagManager';
import { loadSegment } from '@opendoor/shared-fe/segment';
import { createRoot } from 'react-dom/client';

import App from './App';
import { AmplitudeSession } from './config/AmplitudeSession';
import { apolloClient } from './config/apolloClients';
import { SessionContext, Sessions } from './config/context';
import { PartnerContextProvider } from './config/PartnerContext';

import './styles/index.css';

// https://sentry.io/settings/opendoor/projects/partnership-dashboard-fe/keys/
const RAVEN_URL = 'https://bc50f25b43e24d70abc6cf650d88de80@o117144.ingest.sentry.io/1382664';
loadSentry(RAVEN_URL);

loadGoogleTagManager();
loadSegment();
const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

const amplitudeKey = import.meta.env.VITE_AMPLITUDE_KEY;
if (amplitudeKey) {
  amplitude.init(amplitudeKey, {
    autocapture: {
      elementInteractions: true,
    },
  });
}

root.render(
  <ApolloProvider client={apolloClient}>
    <SessionContext.Provider value={Sessions}>
      <AmplitudeSession>
        <PartnerContextProvider>
          <App />
        </PartnerContextProvider>
      </AmplitudeSession>
    </SessionContext.Provider>
  </ApolloProvider>,
);
